function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L52 0L52 44L0 44L0 0Z",
  id: "vue_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "vue_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#vue_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "logo-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L52 0L52 44L0 44L0 0Z",
  id: "logo-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#vue_mask_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.9992 10.1612L19.995 0L0 0L25.9994 43.9996L51.9988 0L32.0036 0L25.9992 10.1612Z",
  transform: "translate(-0.001953125 0.0009765625)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5994 10.1612L9.59525 0L0 0L15.5996 26.3992L31.1992 0L21.6038 0L15.5994 10.1612Z",
  transform: "translate(10.399414 0)",
  id: "Vector",
  fill: "#979797",
  fillRule: "evenodd",
  stroke: "none"
})));

var SvgVue = function SvgVue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "44px",
    viewBox: "0 0 52 44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vue.9e15d934.svg";
export { ForwardRef as ReactComponent };